import { createSlice } from "@reduxjs/toolkit";

import { Industry } from "@/pages/Private/pages/ManageIndustries/industry/schema/industry";

// eslint-disable-next-line import/namespace
import { RootState } from "@/redux";

import { industryApi } from "./industry.api";

const initialState: Industry[] = [];

export const industrySlice = createSlice({
	name: "industry",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(
			industryApi.endpoints.getIndustries.matchFulfilled,
			(_, { payload }) => payload ?? []
		);
		builder.addMatcher(
			industryApi.endpoints.createIndustry.matchFulfilled,
			(state, { payload }) => {
				if (payload?.id) {
					return [...state, payload];
				}
			}
		);
		builder.addMatcher(
			industryApi.endpoints.updateIndustry.matchFulfilled,
			(state, { payload }) => {
				const index = state.findIndex((i) => i.id === payload.id);

				if (index !== -1) {
					state[index] = payload;
				}

				return state;
			}
		);
		builder.addMatcher(
			industryApi.endpoints.deleteIndustry.matchFulfilled,
			(_, { payload }) => payload ?? []
		);
	},
});

export const industryReducer = industrySlice.reducer;
export const industrySelector = (state: RootState) => state[industrySlice.name];
